<template>
  <div id="footer" class="container-fluid">
    <div class="container">
      <div class="links">
        <dl class="visible-lg visible-md">
          <dt>{{ $t('components.Footer.146163-0') }}</dt>
          <dd><a href="/help/list?id=1" target="_blank" class="link">{{ $t('components.Footer.146163-1') }}</a></dd>
          <dd><a href="/help/list?id=2" target="_blank" class="link">{{ $t('components.Footer.146163-2') }}</a></dd>
          <dd><a href="/download" target="_blank" class="link">{{ $t('components.Footer.146163-3') }}</a></dd>
          <dd><a href="/help/list?id=2#4" target="_blank" class="link">{{ $t('components.Footer.146163-4') }}</a></dd>
        </dl>
        <dl class="visible-lg visible-md">
          <dt>{{ $t('components.Footer.146163-5') }}</dt>
          <dd><a href="/help/list?id=4" target="_blank" class="link">{{ $t('components.Footer.146163-6') }}</a></dd>
          <dd><a href="/help/list?id=3#7-24" target="_blank" class="link">{{ $t('components.Footer.146163-7') }}</a></dd>
          <dd><a href="/help/list?id=3#8-26" target="_blank" class="link">{{ $t('components.Footer.146163-8') }}</a></dd>
          <dd><a href="/help/list?id=7#20-62" target="_blank" class="link">{{ $t('components.Footer.146163-9') }}</a></dd>
        </dl>
        <dl class="visible-lg visible-md">
          <dt>{{ $t('components.Footer.146163-10') }}</dt>
          <dd><a href="/about" target="_blank" class="link">{{ $t('components.Footer.146163-11') }}</a></dd>
<!--          <dd>-->
<!--            <a href="http://weibo.com/u/5708944269?topnav=1&wvr=6&topsug=1&is_hot=1" target="_blank" class="link">官方微博</a>-->
<!--          </dd>-->
          <dd>
            <a href="//cdncrystal.bluestonehk.com/download/%E5%AE%98%E7%BD%91%E5%85%8D%E8%B4%A3%E5%A3%B0%E6%98%8E.pdf" target="_blank" class="link">{{ $t('components.Footer.146163-12') }}</a>
          </dd>
          <dd>
            <a href="//cdncrystal.bluestonehk.com/download/%E5%AE%98%E7%BD%91%E6%9C%8D%E5%8A%A1%E6%9D%A1%E6%AC%BE.pdf" target="_blank" class="link">{{ $t('components.Footer.146163-13') }}</a>
          </dd>
          <dd>
            <a href="//cdncrystal.bluestonehk.com/download/%E5%AE%98%E7%BD%91%E9%9A%90%E7%A7%81%E5%A3%B0%E6%98%8E.pdf" target="_blank" class="link">{{ $t('components.Footer.146163-14') }}</a>
          </dd>
        </dl>
        <dl>
          <dt>{{ $t('components.Footer.146163-15') }}</dt>
          <dd><a href="tel:00852-39510777">{{ $t('components.Footer.146163-16') }}(+852){{ $t('components.Footer.146163-17') }}</a></dd>
          <!-- <dd><a href="mailto:CS@bluestonehk.com">内地客服邮箱：CS@bluestonehk.com</a></dd> -->
          <dd><a href="mailto:HKCS@bluestonehk.com">{{ $t('components.Footer.146163-18') }}</a></dd>
          <dd><a href="mailto:BD@bluestonehk.com">{{ $t('components.Footer.146163-19') }}</a></dd>
          <dd><a href="mailto:HR@bluestonehk.com">{{ $t('components.Footer.146163-20') }}</a></dd>
          <!-- <dd>理财师合作: <a href="/partner" class="link a1">去了解>></a></dd> -->
        </dl>
      </div>
      <div class="qr-codes">
<!--        <dl>-->
<!--          <dt class="visible-lg visible-md">扫一扫</dt>-->
<!--          <dd class="hidden-lg hidden-md">关注公众号</dd>-->
<!--          <dd class="img">-->
<!--            <img height="100px" src="//cdncrystal.bluestonehk.com/images/wx_qrcode@2x.png?v=20171127" />-->
<!--          </dd>-->
<!--          <dd class="visible-lg visible-md">关注公众号</dd>-->
<!--        </dl>-->
        <dl style="margin-right:0" class="visible-lg visible-md">
          <dt>&nbsp;</dt>
          <dd class="img"><img height="100px" src="//cdncrystal.bluestonehk.com/images/app_qrcode@2x.png" /></dd>
          <dd>{{ $t('components.Footer.146163-21') }}</dd>
        </dl>
      </div>
      <div class="info visible-lg visible-md">
        <p class="address">{{ $t('components.Footer.146163-22') }} </p>
        <p class="copyright">
          {{ $t('components.Footer.146163-23') }}
        </p>
      </div>
      <div class="info hidden-lg hidden-md">
        <p class="address">{{ $t('components.Footer.146163-24') }}</p>
        <p class="copyright">
          {{ $t('components.Footer.146163-23') }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  data() {
    return {}
  }
}
</script>
<style scoped lang="scss">
#footer {
  background: url(//cdncrystal.bluestonehk.com/images/footer_bg.jpg) no-repeat 0 0;
  background-size: cover;
  padding: 80px 0;
  .container {
    margin: 0 auto;
    .links {
      float: left;
    }
    dl {
      float: left;
      margin-right: 55px;
      dt {
        font-weight: normal;
        font-size: 16px;
        margin-bottom: 55px;
        color: #fff;
      }
      dd {
        font-size: 12px;
        color: #ccd1da;
        margin-bottom: 10px;
        a {
          font-size: 12px;
          color: #ccd1da;
        }
      }
    }
    .qr-codes {
      float: right;
      dl {
        margin-right: 80px;
      }
      dd {
        text-align: center;
      }
    }
  }
  .info {
    clear: both;
    padding-top: 70px;
    p {
      font-size: 12px;
      color: #ccd1da;
      text-align: center;
      opacity: 0.5;
      margin-bottom: 5px;
      a {
        color: #ccd1da;
      }
    }
  }
}
@media screen and (max-width: 997px) {
  #footer {
    padding: 40px 0 50px;
    color: #fff;
    background: url(//cdncrystal.bluestonehk.com/images/wap/footer-bg.png?v=20171108) no-repeat;
    .container {
      .qr-codes {
        dl {
          margin-right: 0px;
        }
      }
      dl {
        margin-right: 5px;
        dt {
          margin-bottom: 15px;
        }
        dd {
          a {
            color: #fff;
          }
        }
      }
      .info {
        padding-top: 20px;
        p {
          text-align: left;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue